import { log } from "@/plugins/consoleLogger";
import { createPayment, checkPaymentStatus, cancelPayment } from "@/services/payments/index";
import { getLocationById } from "@/services/location";
import { fetchTariff } from "@/services/tariff";
import { startSession, getCommand, stopSession } from "@/services/command";
import { getSession } from "@/services/session"
const sessionStore = {
  namespaced: true,
  state: {
    session: {
      token: {
        country_code: undefined,
        party_id: undefined,
        uid: undefined,
        type: undefined,
        contract_id: undefined,
        visual_number: undefined,
        issuer: undefined,
        group_id: undefined,
        valid: undefined,
        whitelist: undefined,
        language: undefined,
        last_updated: undefined
      },
      location: {
        countryCode: undefined,
        partyId: undefined,
        locationId: undefined,
        evseUid: undefined,
        name: undefined,
        address: undefined,
        city: undefined,
        country: undefined,
        tariff: undefined,
        timezone: undefined
      },
      evses: undefined,
      status: undefined,
      paymentId: undefined,
      payment: undefined,
      commandSent: undefined
    }
  },
  getters: {
    getSession(state) {
      return state.session;
    },

    getSessionToken(state) {
      return state.session.token;
    },

    getLocation(state) {
      return state.session.location;
    },

    getSessionStatus(state) {
      return state.session.status;
    },

    getTariff(state) {
      return state.session.location.tariff;
    },

    getEvses(state) {
      return state.session.evses;
    },

    getTimezone(state) {
      return state.session.location.timezone
    },

    getTransaction(state) {
      return state.session.payment;
    },

    getCommandSent(state) {
      return state.session.commandSent;
    },
    getPaymentId(state) {
      return state.session.paymentId;
    }
  },
  mutations: {
    clear(state, test) {
      state.session.token.country_code = undefined,
      state.session.token.party_id= undefined,
      state.session.token.uid= undefined,
      state.session.token.type = undefined,
      state.session.token.contract_id = undefined,
      state.session.token.visual_number = undefined,
      state.session.token.issuer = undefined,
      state.session.token.group_id = undefined,
      state.session.token.valid = undefined,
      state.session.token.whitelist = undefined,
      state.session.token.language = undefined,
      state.session.token.last_updated = undefined
      state.session.location.countryCode = undefined,
      state.session.location.partyId = undefined,
      state.session.location.locationId = undefined,
      state.session.location.evseUid = undefined,
      state.session.location.name = undefined,
      state.session.location.address = undefined,
      state.session.location.city = undefined,
      state.session.location.country = undefined,
      state.session.location.tariff = undefined,
      state.session.location.timezone = undefined,
      state.session.evses = undefined,
      state.session.status = undefined,
      state.session.paymentId = undefined,
      state.session.payment = undefined,
      state.session.commandSent = undefined
    },
    saveToken(state, payload) {
      if (payload.token === undefined) {
        state.session.status = "Authorized";
      }
      else {
        state.session.token = payload.token;
        state.session.status = "Pending";
      }
    },
    changeStatusToUndefined(state) {
      state.session.status = undefined;
    },
    changeStatusToActive(state) {
      state.session.status = "Active";
    },
    changeStatusToCompleted(state) {
      state.session.status = "Completed";
    },
    changeStatusToCreated(state) {
      state.session.status = "Created";
    },
    resetStatus(state) {
      state.session.status = undefined;
    },
    setEvseUid(state, value) {
      state.session.location.evseUid = value;
    },
    setEvses(state, value) {
      state.session.evses = value;
    },
    setCountryCode(state, value) {
      state.session.location.countryCode = value;
    },
    setPartyId(state, value) {
      state.session.location.partyId = value;
    },
    setLocationId(state, value) {
      state.session.location.locationId = value;
    },
    setName(state, value) {
      state.session.location.name = value;
    },
    setAddress(state, value) {
      state.session.location.address = value;
    },
    setCity(state, value) {
      state.session.location.city = value;
    },
    setCountry(state, value) {
      state.session.location.country = value;
    },
    setTariff(state, value) {
      state.session.location.tariff = value
    },
    setTimezone(state, value) {
      state.session.location.timezone = value
    },
    setPaymentId(state, value) {
      state.session.paymentId = value
    },
    setPayment(state, value) {
      state.session.payment = value
    },
    setCommandSent(state) {
      state.session.commandSent = true
    }
  },
  actions: {
    async createPayment(_, body) {
      try {
        const data = await createPayment(body);
        return data
      } catch (error) {
        log("error", "error executing 'createPayment' : ", error);
        throw error;
      }
    },

    async checkPaymentStatus(_, transactionID) {
      try {
        return await checkPaymentStatus(transactionID);
      } catch (error) {
        log("error", "error executing 'checkPaymentStatus' : ", error);
        throw error;
      }
    },

    async cancelPayment(_, transactionID) {
      try {
        return await cancelPayment(transactionID);
      } catch (error) {
        log("error", "error executing 'cancelPayment' : ", error);
        throw error;
      }
    },

    async fetchLocationById({ commit }, { locationId, countryCode, partyId }) {
      log("log", "fetching location by ID")
      const location = await getLocationById(locationId, countryCode, partyId);

      log("log", "after fetching location by ID");

      if (!location) {
        throw new Error("This locations does not exist");
      }
      if (location.evses.length == 0) {
        throw new Error("This locations does not contain any EVSE");
      }

      commit("setCountryCode", location.country_code);
      commit("setPartyId", location.party_id);
      commit("setLocationId", location.id);
      commit("setName", location.name);
      commit("setAddress", location.address);
      commit("setCity", location.city);
      commit("setCountry", location.country);
      commit("setTimezone", location.time_zone);

      return location;
    },

    async fetchTariff(_, data) {
      const tariff = await fetchTariff(data)

      if(!tariff) {
        throw new Error("No tariff matches this id");
      }

      return tariff
    },

    async startSession(_, data) {
      try {
        return await startSession(data);
      } catch (error) {
        log("error", "error executing 'startSession' : ", error);
        throw error;
      }
    },

    async getCommand(_, uid) {
      try {
        return await getCommand(uid)
      } catch (error) {
        log("error", "error executing 'getCommand' : ", error);
        throw error;
      }
    },

    async getSession(_, uid) {
      try {
        return await getSession(uid)
      } catch (error) {
        log("error", "error executing 'getSession' : ", error);
        throw error;
      }
    },

     async stopSession(_, id) {
      try {
        return await stopSession(id)
      } catch (error) {
        log("error", "error executing 'stopSession' : ", error);
        throw error;
      }
     }
  }
};

export default sessionStore;
